import gsap from 'gsap';
import MorphSVGPlugin from 'gsap/MorphSVGPlugin';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { IconBase } from '../Base';
gsap.registerPlugin(MorphSVGPlugin);
const Wrapper = styled.div `
  --icon-hand-coins-1-y: 0px;
  --icon-hand-coins-1-x: 0px;
  --icon-hand-coins-2-y: 0px;
  --icon-hand-coins-2-x: 0px;
  --icon-hand-rotate: 0deg;
`;
const Circle = styled.circle `
  fill: var(--icon-background, ${({ theme }) => theme.background});
  transform: translate(var(--icon-hand-coins-1-x), var(--icon-hand-coins-1-y)) translateZ(0);
`;
const CircleSecond = styled(Circle) `
  transform: translate(var(--icon-hand-coins-2-x), var(--icon-hand-coins-2-y)) translateZ(0);
`;
const Hand = styled.g `
  fill: var(--icon-background, ${({ theme }) => theme.background});
  transform-origin: 21.25% 70.85%;
  transform: rotate(var(--icon-hand-rotate)) translateZ(0);
`;
export const IconHandCoins = (props) => {
    const wrapperRef = createRef();
    const handPathRef = createRef();
    const triggerDone = () => {
        if (props.onDone) {
            props.onDone();
        }
    };
    useEffect(() => {
        if (props.running) {
            const wrapper = wrapperRef.current;
            const handPath = handPathRef.current;
            if (!wrapper || !handPath) {
                return;
            }
            gsap.to(wrapper, {
                keyframes: [
                    {
                        '--icon-hand-coins-1-y': '-3px',
                        duration: 0.1,
                        onStart: () => {
                            gsap.to(wrapper, {
                                keyframes: [
                                    {
                                        '--icon-hand-coins-2-y': '-3px',
                                        duration: 0.1,
                                        delay: 0.1,
                                    },
                                    {
                                        '--icon-hand-coins-2-y': '10px',
                                        '--icon-hand-coins-2-x': '2px',
                                        duration: 0.2,
                                    },
                                ],
                            });
                        },
                    },
                    {
                        '--icon-hand-coins-1-y': '11px',
                        '--icon-hand-coins-1-x': '4px',
                        '--icon-hand-rotate': '14deg',
                        duration: 0.2,
                        onStart: () => {
                            gsap.to(handPath, {
                                keyframes: [
                                    {
                                        morphSVG: 'M6 16.5L10.6817 17.4364C10.8925 17.4785 11.1087 17.4864 11.322 17.4597L14.9595 17.0051C14.9865 17.0017 15.0124 16.998 15.0392 16.993C15.3913 16.928 18 16.3988 18 15C18 13.5 15.3441 14.3244 13.5 14.5C12.7225 14.5741 10.83 14.17 10.83 14.17',
                                        duration: 0.2,
                                    },
                                    {
                                        morphSVG: 'M6 16.5L10.559 17.4118C10.8494 17.4699 11.149 17.4627 11.4363 17.3909L14.6404 16.5899C14.8781 16.5305 15.1018 16.4295 15.2959 16.2799C16.138 15.6313 18.428 13.6977 17.5 12.5C16.3717 11.0439 14.8441 13.9944 13 14.17C12.2225 14.244 10.83 14.17 10.83 14.17',
                                        duration: 0.2,
                                        delay: 0.1,
                                    },
                                ],
                            });
                        },
                    },
                    {
                        '--icon-hand-rotate': '-6deg',
                        duration: 0.1,
                        delay: 0.2,
                        onStart: () => {
                            gsap.to(wrapper, {
                                '--icon-hand-coins-1-y': '0px',
                                '--icon-hand-coins-1-x': '0px',
                                '--icon-hand-coins-2-y': '0px',
                                '--icon-hand-coins-2-x': '0px',
                                duration: 0.8,
                                ease: 'elastic.out(1, .8)',
                                clearProps: true,
                                onComplete: triggerDone,
                            });
                        },
                    },
                    {
                        '--icon-hand-rotate': '0deg',
                        duration: 0.25,
                    },
                ],
            });
        }
    }, [props.running]);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(IconBase, null,
            React.createElement("g", { strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
                React.createElement(CircleSecond, { cx: "12.5", cy: "5.5", r: "2.5" }),
                React.createElement(Circle, { cx: "9.5", cy: "4.5", r: "2.5" }),
                React.createElement(Hand, null,
                    React.createElement("path", { ref: handPathRef, d: "M6 16.5L10.559 17.4118C10.8494 17.4699 11.149 17.4627 11.4363 17.3909L14.6404 16.5899C14.8781 16.5305 15.1018 16.4295 15.2959 16.2799C16.138 15.6313 18.428 13.6977 17.5 12.5C16.3717 11.0439 14.8441 13.9944 13 14.17C12.2225 14.244 10.83 14.17 10.83 14.17" }),
                    React.createElement("path", { d: "M5 17.5H3.33333C3.11232 17.5 2.90036 17.4122 2.74408 17.2559C2.5878 17.0996 2.5 16.8877 2.5 16.6667V11.6667C2.5 11.4456 2.5878 11.2337 2.74408 11.0774C2.90036 10.9211 3.11232 10.8333 3.33333 10.8333H5C5.22101 10.8333 5.43297 10.9211 5.58926 11.0774C5.74554 11.2337 5.83333 11.4456 5.83333 11.6667V16.6667C5.83333 16.8877 5.74554 17.0996 5.58926 17.2559C5.43297 17.4122 5.22101 17.5 5 17.5Z" }),
                    React.createElement("path", { d: "M10.8333 14.1667H12.0708C12.7683 14.1667 13.3333 13.6017 13.3333 12.9042V12.6517C13.3333 12.0725 12.9391 11.5675 12.3775 11.4275L10.4675 10.95C9.93847 10.8175 9.38759 10.7971 8.85025 10.8903C8.31292 10.9834 7.80102 11.188 7.34748 11.4908L5.83331 12.5" }))))));
};
//# sourceMappingURL=HandCoins.js.map